/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const o=15.5,t=4,c=64,e=1024;export{o as dashRadius,c as dashSdfDistanceNormalization,t as dashSdfRasterizationScale,e as maxTileCoordValue};
